import {useTranslation} from "react-i18next";
import React from "react";
import {faFilter} from "@fortawesome/free-solid-svg-icons/faFilter";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function InstallationsFilter({ displayFilter, filter, setFilter, hideFilterAlarmed }) {
  const {t} = useTranslation();

  if(!displayFilter)
    return <></>;

  return (
      <div className="installation-filters">
        <h4 className={'installation-filters'}><FontAwesomeIcon icon={faFilter}/> {t('installations.filter')}</h4>
        <form
            aria-label="Filter input form"
            className="flex flex-col gap-5"
            onSubmit={e => e.preventDefault()}
        >
          <label
              className="filter-label"
              htmlFor="title"
          >
            <b>{`${t('installations.filterTitle')}: `}</b>
            <input
                aria-label="Filter by title"
                autoComplete="off"
                className="cinput"
                id="title"
                onChange={e => setFilter(f => ({ ...f, title: e.target.value }))}
                placeholder="*"
                type="text"
                value={filter?.title ? filter?.title : ""}
            />
          </label>
          <label
              className="filter-label"
              htmlFor="description"
          >
            <b>{`${t('installations.filterDescription')}: `}</b>
            <input
                aria-label="Filter by description"
                autoComplete="off"
                className="cinput"
                id="description"
                onChange={e => setFilter(f => ({ ...f, description: e.target.value }))}
                placeholder="*"
                type="text"
                value={filter?.description ? filter?.description : ""}
            />
          </label>
          <label
              className="filter-label"
              htmlFor="serial"
          >
            <b>{`${t('installations.filterSerial')}: `}</b>
            <input
                aria-label="Filter by serial number"
                autoComplete="off"
                className="cinput"
                id="serial"
                onChange={e => setFilter(f => ({ ...f, id: e.target.value }))}
                placeholder="*"
                type="text"
                value={filter?.id ? filter?.id : ""}
            />
          </label>
          {!hideFilterAlarmed && (
            <label
                className="checkbox-label filter-alarmed-checkbox"
                htmlFor="filter-alarmed-checkbox"
            >
              <input
                  defaultChecked={filter.filterAlarmed}
                  id="filter-alarmed-checkbox"
                  name="filter-alarmed-checkbox"
                  onBlur={() => {document.getElementById("checkmark-filter-armed").classList.remove("focus")}}
                  onChange={() => setFilter(f => ({ ...f, filterAlarmed: !f.filterAlarmed }))}
                  onFocus={() => {document.getElementById("checkmark-filter-armed").classList.add("focus")}}
                  type="checkbox"
              />
              {t('installations.filterAlarmed')}
              <span className="checkmark" id='checkmark-filter-armed'/>
            </label>)
          }
        </form>
      </div>
  );
}